import { ActionBar, DeleteDialog, FormDialog } from './components';
import { LoaiVatTu, LoaiVatTuInput } from '@/types/schemas';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { getItemTypeColumns } from './cols-definition';
import { useCRUD, useForms } from '@/hooks';
import { QUERY_KEYS } from '@/constants';
import { useSearchTable } from './hooks';

const PAGE_SIZE = 20;

export default function Page() {
  const {
    data,
    totalItems,
    currentPage,
    detail,
    fetchDetail,
    handlePageChange,
    addItem,
    updateItem,
    deleteItem,
    refreshData,
    searchData
  } = useCRUD<LoaiVatTu, LoaiVatTuInput>({
    endpoint: QUERY_KEYS.LOAI_VAT_TU,
    pageSize: PAGE_SIZE
  });

  const {
    showForm,
    showDelete,
    formMode,
    selectedObj,
    selectedRowIndex,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useForms<LoaiVatTu>(fetchDetail);

  const { searchState, handleSearchChange, onPageChange, hasFilterParams } = useSearchTable({
    searchData,
    isFiltered: false,
    handlePageChange: handlePageChange
  });

  const displayData = hasFilterParams ? searchState.searchResults : data || [];
  const resolvedCurrentPage = hasFilterParams ? searchState.currentPage : currentPage;
  const resolvedTotalItems = hasFilterParams ? searchState.totalCount : totalItems;

  const tables = [
    {
      name: '',
      rows: displayData,
      columns: getItemTypeColumns(handleViewClick)
    }
  ];

  const handleFormSubmit = async (data: LoaiVatTuInput) => {
    try {
      if (formMode === 'add') {
        await addItem(data);
      } else if (formMode === 'edit' && selectedObj) {
        await updateItem(selectedObj.uuid, data);
      }
      refreshData();
      handleCloseForm();
      clearSelection();
    } catch (error) {
      return;
    }
  };

  return (
    <div className='flex h-full min-h-[calc(100vh-120px)] w-full flex-col'>
      <ActionBar
        onAddClick={handleAddClick}
        onEditClick={() => selectedObj && handleEditClick()}
        onViewClick={() => selectedObj && handleViewClick()}
        onDeleteClick={() => selectedObj && handleDeleteClick()}
        onCopyClick={() => selectedObj && handleCopyClick()}
        onRefreshClick={refreshData}
      />

      <ErpDataTableV2
        tables={tables}
        onRowClick={handleRowClick}
        selectedRowId={selectedRowIndex || undefined}
        totalItems={resolvedTotalItems}
        currentPage={resolvedCurrentPage}
        onPageChange={onPageChange}
        serverSidePagination={true}
        pageSize={PAGE_SIZE}
        onSearchChange={handleSearchChange}
      />

      {showForm && (
        <FormDialog
          open={showForm}
          formMode={formMode}
          initialData={formMode === 'add' && !isCopyMode ? undefined : detail}
          onAddButtonClick={handleAddClick}
          onEditButtonClick={handleEditClick}
          onDeleteButtonClick={handleDeleteClick}
          onCopyButtonClick={handleCopyClick}
          onClose={handleCloseForm}
          onSubmit={handleFormSubmit}
        />
      )}

      {showDelete && (
        <DeleteDialog
          open={showDelete}
          onClose={handleCloseDelete}
          selectedObj={selectedObj}
          deleteLoaiVatTu={deleteItem}
          clearSelection={clearSelection}
        />
      )}
    </div>
  );
}
